import { Component } from '@verndale/core';

class SwiperObserver extends Component {
  setupDefaults() {
    this.dom = {
      $swiperWrapper: this.el._$('.swiper-wrapper')
    };
    const config = { attributes: true, subtree: true };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          this.setClassName();
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(this.dom.$swiperWrapper, config);
  }

  setClassName() {
    const slides = this.dom.$swiperWrapper._$$('.swiper-slide');
    const allSlidesVisible = slides.every(($slide) => {
      return $slide.classList.value === 'swiper-slide';
    });

    this.dom.$swiperWrapper.classList.toggle(
      'all-slides-visible',
      allSlidesVisible
    );
  }
}

export default SwiperObserver;
